import React from 'react';

import './styles.scss';

function FullPageText({ text = 'Samantha almost ready for you', color = 'white', background = 'initial' }) {
  const styles = {
    background,
    color,
  };

  const textStyles = {
    color,
  };

  return (
    <div className="full-page-text" style={styles}>
      <p className="full-page-text__text" style={textStyles}>{ text } </p>
    </div>
  );
}

export default FullPageText;